<template>
  <div v-if="nouveauDevisCommande">
    <a ref="lienDownload"></a>
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <div>
                <h1 class="title is-size-3" v-if="isNewDevisCommande">
                  {{ $t('editionCommande.title')}}
                  <span class="is-size-6 has-text-weight-light has-text-default">
                    {{ getTitle }}
                  </span>
                </h1>
                <h1 class="title is-size-3" v-else>
                  {{ getUpdateTitle }}
                  <span class="is-size-6 has-text-weight-light has-text-default">
                    {{ getTitle }}
                  </span>
                </h1>
              </div>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right" v-if="canSeeCommande">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-cancel btn-modal-annuler " @click="annuler()">
              {{ $t('editionCommande.actions.revert')}}
            </a>
            <a class="button is-addOrEdit " @click="checkBeforeSave()">
              {{ $t('general.button.sauvegarder') }}
            </a>
            <button class="button" v-if="isPublid">
              <b-dropdown position="is-bottom-left" class="positionInitial">
                <b-icon icon="dots-vertical" slot="trigger" role="button" type="is-default">
                </b-icon>
                <b-dropdown-item @click="getExcelProduitReseauNum()">
                  {{ $t('exportExcelReseauNum.exportExcel') }}
                </b-dropdown-item>
                <b-dropdown-item @click="popUpImportExcel = true">
                  {{ $t('exportExcelReseauNum.importExcel') }}
                </b-dropdown-item>
              </b-dropdown>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.COMMANDES.maj">
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                          :error="error"
                          :title="'editionClient.problemOccurred'"
                          :withEmplyFields="true"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          @close="error = $event"/>
      <avertissement-msg-component :messages="messagesWarning"
                                   :avertissement="warning"
                                   :title="'general.warning'"
                                   @close="warning = $event"/>
      <app-information-msg-component
        v-if="nouveauDevisCommande.besoins && nouveauDevisCommande.besoins.length && !!id"
        :title="'general.info'"
        :libelleList="[{isLink:false, libelle:$t('editionCommande.messages.commandeHasBesoins')}]"
        :canClose="true">
      </app-information-msg-component>
      <div class="tab" v-if="canSeeCommande">
        <ul>
          <li :class="[{'is-active': activeTab === 'commande'}]"
            @click="setActiveTabCommande()">
            {{ $t('editionCommande.tabs.quotation') }}
          </li>
          <li :class="{'is-active': activeTab === 'logistique'}"
              @click="activeTab = 'logistique'">
            <b-field>
              <div class="mgv-auto mgr-5px round-circle-warning"
                   v-if="displayRoundAlerteLogistique"></div>
              <span> {{ $t('editionCommande.tabs.logistique') }}</span>
            </b-field>
          </li>
          <li :class="[{ 'is-active': activeTab === 'achats' }]"
            @click="activeTab = 'achats'" v-if="nouveauDevisCommande.role !== constantes.REGIE">
            {{ $t('editionCommande.tabs.achat') }}
          </li>
          <li :class="[{'is-active': activeTab === 'commissions'}]"
            @click="activeTab = 'commissions'" v-if="modulePresseActive">
            {{ $t('editionCommande.tabs.commissions') }}
          </li>
          <li :class="[{'is-active': activeTab === 'echeancierFacturation'}]"
             @click="activeTab = 'echeancierFacturation'">
            {{ $t('editionCommande.tabs.echeancierFacturation') }}
          </li>
          <li :class="[{'is-active': activeTab === 'previsualisation'}]"
            @click="activeTab = 'previsualisation'">
            {{ $t('editionCommande.tabs.previsualisation') }}
          </li>
          <li :class="[{'is-active': activeTab === 'etatSuiviDevisCommande'}]"
            @click="activeTab = 'etatSuiviDevisCommande'" v-if="modulePresseActive">
            {{ $t('editionCommande.tabs.etatSuiviDevisCommande') }}
          </li>
        </ul>
      </div>
      <div v-else>
        <app-information-msg-component :title="'general.info'"
                                       :libelleList="[{ isLink: false,
                                       libelle: $t('general.noAccess') }]"
                                       :canClose="false"
        >
        </app-information-msg-component>
      </div>
    </div>
    <div class="pdt-20px"
         v-if="canSeeCommande && activeTab === 'commande'">
      <div class="card">
        <header class="header-card">
          <p>
            {{ $t('editionCommande.generalTitle.generalInformations')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-2">
              <b-field :label="$t('editionCommande.informations.quotationDate')">
                  <b-datepicker show-week-number
                    nearby-selectable-month-days
                    v-model="nouveauDevisCommande.dateDevisCommande"
                    icon="calendar-today"
                    :editable="true">
                  </b-datepicker>
              </b-field>
            </div>
            <div class="column is-1">
              <b-field class="bfieldWhitoutLabel">
                <b-checkbox
                  v-model="nouveauDevisCommande.estSigne">
                  {{ $t('editionCommande.informations.estSigne') }}
                </b-checkbox>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('editionCommande.informations.validityDate')">
                <b-datepicker show-week-number
                  nearby-selectable-month-days
                  v-model="nouveauDevisCommande.dateValidite"
                  icon="calendar-today"
                  :editable="true">
                </b-datepicker>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('editionCommande.informations.datePremierAffichage')">
                <b-datepicker show-week-number
                              nearby-selectable-month-days
                              v-model="nouveauDevisCommande.datePremierAffichage"
                              icon="calendar-today"
                              :editable="true"
                              :disabled="isDateCampagneDisabled">
                </b-datepicker>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('editionCommande.informations.categorieVente')">
                <b-select expanded v-model="nouveauDevisCommande.categorieVente"
                          @input="checkCategorieVente">
                  <option :key="categorieVente.code"
                          :value="categorieVente.code"
                          v-for="categorieVente in categorieProduit">
                    {{ $t(categorieVente.libelle) }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-3">
              <user-selector
                v-model="nouveauDevisCommande.commercialId"
                @input="setCommissions"
                :critere="(u) => [constantes.COMMERCIAL, constantes.DIRECTEUR_COMMERCIAL]
                  .includes(u.profil)"
                :placeholder="$t('editionCommande.informations.aucunCommercial')"
                :label="$t('editionCommande.informations.trade')"
                :disabled="isCommercial"
                :obligatoire="assistantEtCommercialObligatoireSurCommandeFacture"
              />
            </div>
            <div class="column is-1">
              <b-field :label="$t('editionCommande.informations.commission')">
                <input-currency v-model="nouveauDevisCommande.commissionCommercial" isNumber="true">
                </input-currency>
                <span class="icon is-right pdt-15px">
                  <i>%</i>
                </span>
              </b-field>
            </div>
            <div class="column is-2">
              <user-selector
                v-model="nouveauDevisCommande.assistantId"
                :critere="(u) => [constantes.ASSISTANT_COMMERCIAL]
                  .includes(u.profil)"
                :label="$t('editionCommande.informations.assistant')"
                :placeholder="$t('editionCommande.informations.aucunAssistant')"
                :obligatoire="assistantEtCommercialObligatoireSurCommandeFacture"
              />
            </div>
            <div class="column is-3">
              <b-field :label="$t('editionCommande.informations.agence')"
                       class="obligatoire">
                <b-select expanded v-model="nouveauDevisCommande.agenceId">
                  <option :key="agence.agenceId"
                          :value="agence.agenceId"
                          v-for="agence in agencesSelectionnees">
                    {{agence.libelleAgence}}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-3" v-if="societeActive.roles.length > 1">
              <b-field :label="$t('editionCommande.informations.role')" class="obligatoire">
                <b-select expanded v-model="nouveauDevisCommande.role">
                  <option :key="role.code" :value="role.code"
                          v-for="role in getRoleOfCurrentSociete">
                    {{ $t(role.libelle) }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('editionCommande.informations.customerReference')">
                <b-input v-model="nouveauDevisCommande.referenceClient">
                </b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('editionCommande.informations.folderCode')">
                <b-input v-model="nouveauDevisCommande.codeDossier"/>
              </b-field>
            </div>
            <div v-if="moduleCampagneActive"
              class="column" :class="societeActive.roles.length > 1 ? 'is-6' : 'is-3'">
              <selection-campagne
                :label="$t('editionCommande.informations.campagne')"
                :dcf="nouveauDevisCommande"></selection-campagne>
            </div>
            <div class="column is-6">
              <b-field :label="$t('editionCommande.informations.theme')">
                <b-input v-model="nouveauDevisCommande.theme"></b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('editionCommande.informations.tags')">
                <query-tags-tag-input
                  :tooltipLabel="$t('editionCommande.informations.tagInfo')"
                  position="is-top"
                  v-model="nouveauDevisCommande.tags"
                  field="tag"
                  :moduleTag="constantes.DOCUMENT_VENTE">
                </query-tags-tag-input>
              </b-field>
            </div>
            <div class="column is-3" v-if="modulePlanMediaActive">
              <b-field :label="$t('editionCommande.informations.planMedia')">
                <b-autocomplete
                  :value="searchPlanMedia"
                  :data="planMediaFilter"
                  :loading="isFetchingPlanMedia"
                  :disabled="!!$route.params.planMediaId"
                  @select="setPlanMedia"
                  @input="getAsyncPlanMediaData"
                  field="code"
                  icon="magnify"
                  type="is-primary"
                  open-on-focus>
                  <template slot="empty">
                    <div v-if="!isFetchingPlanMedia">
                      {{$t('general.autocomplete.noRslt')}}
                    </div>
                    <div v-else>
                      {{$t('general.autocomplete.search')}}
                    </div>
                  </template>
                </b-autocomplete>
              </b-field>
            </div>
            <div class="column is-3" v-if="modulePresseActive">
              <b-field
                    :label="$t('editionCommande.informations.regleFacturation.label')"
                    :message="!isSyncRegleWithLignes ?
                              $t('editionCommande.informations.regleFacturation.erreur') : ''"
                    :type="!isSyncRegleWithLignes ? 'is-warning' : ''">
                <b-select expanded v-model="nouveauDevisCommande.regleFacturationId">
                  <option :value="null"></option>
                  <option
                      v-for="regle in reglesFacturation"
                      :key="regle.id"
                      :value="regle.id">
                    {{ regle.libelle }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="pdt-20px">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('editionCommande.generalTitle.clientsSelect')}}
            </p>
          </header>
          <div class="card-content">
            <app-selection-client :nouveauDevisCommande="nouveauDevisCommande"
                                  @calcul="calcul"
                                  @deleteOrDeselectPayeurInEcheancier=
                                    "deleteOrDeselectPayeurInEcheancier"/>
          </div>
        </div>
      </div>
      <app-renouvellement :devisCommande="nouveauDevisCommande"/>
      <div class="pdt-20px">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('editionCommande.generalTitle.articles')}}
            </p>
          </header>
          <div class="card-content">
            <liste-lignes-ventes
              :dcf="nouveauDevisCommande"
              :error="error"
              :breadcrumb="breadcrumb"
              @typeProduitChange="findNewTypeProduit() "
              @calcul="calcul"
              @messagesErrors="showErrorsMessages">
            </liste-lignes-ventes>
          </div>
          <app-conditions-reglement :devisCommande="nouveauDevisCommande"
                                    racineTraduction="editionCommande" />
        </div>
      </div>
      <div v-if="moduleIndexationCommandeActive" class="pdt-20px">
        <indexation-commande :commande="nouveauDevisCommande"/>
      </div>
      <div class="pdt-20px">
        <commentaires
          :type="nouveauDevisCommande.type"
          :devisCommandeFacture="nouveauDevisCommande">
        </commentaires>
      </div>
      <div class="pdt-20px">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('piecesJointes.attachments')}}
            </p>
          </header>
          <div class="card-content">
            <app-pieces-jointes :checkPermissions="true"/>
          </div>
        </div>
      </div>
    </div>
    <commissions :plan-media="nouveauDevisCommande"
                 v-if="activeTab === 'commissions'"></commissions>
    <echeancier-facturation :dcf="nouveauDevisCommande"
                            :showErrorDate="showErrorDate"
                            v-if="canSeeCommande && activeTab === 'echeancierFacturation'"
    />
    <app-logistique v-if="canSeeCommande && activeTab === 'logistique'"
                    :breadcrumb="breadcrumb"
                    :commande="nouveauDevisCommande" :ordresTravails="ordresTravails"
    ></app-logistique>
    <edition-achat-devis-commande :devisCommande="nouveauDevisCommande"
                                  v-if="activeTab === 'achats'">
    </edition-achat-devis-commande>
    <app-previsualisation v-if="canSeeCommande && activeTab === 'previsualisation'"
                          :isEditPrevisu="isEditPrevisu"
                          :isEdit="true"
                          :dcf="nouveauDevisCommande"
                          @changeIsEditPrev="isEditPrevisu = $event"
                          @masqueLigneChange="masqueLigneChange"
                          @masqueRemiseChange="nouveauDevisCommande.masqueRemise = $event">
    </app-previsualisation>
    <etat-suivi-devis-commande
      v-if="canSeeCommande && activeTab === 'etatSuiviDevisCommande' && modulePresseActive"
      :isEdit="true"
      v-model="nouveauDevisCommande"
    />
    <b-modal v-model="modal.error"
             has-modal-card
             class="modal">
      <popup-erreur
        :messHeader="modal.title"
        :messages="[{ isLink: false, libelle: modal.subtitle }]"
      />
    </b-modal>
    <b-modal v-model="modal.prevention"
             has-modal-card
             class="modal">
      <pop-up-prevention :messHeader="modal.title"
                         :messDescription="modal.subtitle"
                         :validate="$t('general.button.next')"
                         :cancel="$t('general.button.cancel')"
                         @yes="checkAlredyPassErrorDateOrTotal()"
                         @no="displayErrorEcheancier"/>
    </b-modal>
    <b-modal v-model="popUpProduit" has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('editionCommande.popUpProduct.title')"
        :messagesHtml="lignesSansProduitMessage"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpProduit = false;"
        @yes="saveCommande">
        {{ nouveauDevisCommande.lignesCommande.libelle }}
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="isComponentPopUpErreurPerso"
      has-modal-card
      class="modal">
      <popup-erreur
          :messHeader="this.$t('ligneRegroupementPersonnalisee.popup.unableToCreate')"
          :messagesPopup="messagesPopup"
      />
    </b-modal>
    <b-modal v-model="popUpImportExcel"
             has-modal-card
             class="modal">
      <pop-up-import-excel
        :haveAlreadyVente="nouveauDevisCommande.lignesCommande.length > 0"
        @addXlsxFile="readAndCreateLignes">
      </pop-up-import-excel>
    </b-modal>
    <b-modal v-model="popUpChoiceSavePrevisualisation"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('previsualisation.titlePopUp')"
        :cancel="$t('previsualisation.actions.cancel')"
        :validate="$t('previsualisation.actions.saveWithNewPrevisualisation')"
        :otherButton="$t('previsualisation.actions.saveWithoutNewPrevisualisation')"
        @no="popUpChoiceSavePrevisualisation = false"
        @yes="saveWithChange"
        @otherButtonSelect="saveWithoutChange"
      ></pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import debounce from 'lodash/debounce';
import AppBreadcrumb from '@/components/general/breadcrumb';
import calculCommandeDevis from '@/services/devisCommandes/calcul/calculCommandeDevis';
import * as devisConf from '@/configuration/devisConf';
import initializeCommandeDevis from '@/services/devisCommandes/initializeCommandeDevis';
import genererDevisCommande from '@/services/devisCommandes/genererDevisCommande';
import reordonnancementRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/reordonnancementRegroupementPersonnalise';
import PiecesJointes from '@/components/general/piecesJointes';
import { create, update } from '@/api/commande/index';
import { commandeGetterAsync as devisCommandeGetter } from '@/services/devisCommandes/devisCommandeGetter';
import commandeRenouvellementTaciteGetter from '@/services/devisCommandes/commandeRenouvellementTaciteGetter';
import validationGeneral from '@/services/validation/validation';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import translate from '@/services/devisCommandes/validation/champsCommandeTranslator';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import * as types from '@/store/modules/commande-mutation-type';
import * as typesClient from '@/store/modules/clients-mutation-type';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import addIntervenant from '@/services/devisCommandes/addIntervenant';
import creerIntervenant from '@/services/devisCommandes/creerIntervenant';
import { GUID_VIDE } from '@/configuration/general';
import preparationEnvoiBack from '@/services/devisCommandes/preparationEnvoiBack/preparationEnvoiBack';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { COMMERCIAL, ASSISTANT_COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { getAll } from '@/api/logistique/demandeLogistique/index';
import { getAll as getAllPlanMedia } from '@/api/planMedia';
import serverTableDataTransformer from '@/services/planMedia/serverTableDataTransformer';
import { RESULTS_PER_PAGE } from '@/configuration/clientTableConf';
import {
  ajouterProduitDepuisPanierNumerique,
  ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo,
} from '@/services/devisCommandes/ajoutProduit/ajouterProduitDepuisPanier';
import * as typesProduitNumerique from '@/store/modules/produitEcranNumerique-mutation-type';
import * as typesProduitFace from '@/store/modules/produitFace-mutation-type';
import * as typesProduitReseauLc from '@/store/modules/produitReseauLc-mutation-type';
import * as typesProduitReseauMairie from '@/store/modules/bodac/catalogue/produitReseauMairie-mutation-type';
import * as typesProduitSalon from '@/store/modules/bodac/catalogue/produitSalon-mutation-type';
import * as typesProduitPresse from '@/store/modules/bodac/catalogue/produitPresse-mutation-type';
import * as produitConf from '@/configuration/catalogue/produitConf';
import listeLignesVentes from '@/components/devisCommandes/editionDevisCommande/listeLignesVentes';
import popupErreur from '@/components/general/popUpErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import popUpImportExcel from '@/components/devisCommandes/editionDevisCommande/p_importExcel';
import readFileXlsx from '@/services/general/readFileXlsx';
import fromLignesXlsxToTab from '@/services/excel/produitReseauNumerique/fromLignesXlsxToTab';
import { ajoutLignesCommandeProduitReseauNumfromXlsx } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauNumerique';
import * as typesProduitReseauTempo from '@/store/modules/planningReseauTempo-mutation-type';
import categorieVenteInitialize from '@/services/devisCommandes/categorieVenteInitialize';
import { updateAffectionOfAllProduct } from '@/services/affectation/affectation';
import commentaires from '@/components/bodac/dcf/addEditDcf/commentaires/commentaires';
import AppLogistique from '@/components/devisCommandes/editionDevisCommande/logistiqueCommande';
import AppPrevisualisation from '@/components/devisCommandeFacture/previsualisation/previsualisation';
import updateMasqueLigneWithOrdre from '@/services/devisCommandes/ligneCommande/updateMasqueLigneWithOrdre';
import popUpPrevention from '@/components/general/popUpPrevention';
import echeancierFacturation from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/echeancierFacturation';
import { checkUnconsecutiveDateEcheancier } from '@/services/commande/echeancierFacturation/checkUnconsecutiveDateEcheanciers';
import getLignesCommandesWithReferenceEcheancier from '@/services/commande/echeancierFacturation/getLignesCommandesWithReferenceEcheancier';
import { getOdresTravailsOfCommande } from '@/api/logistique/ordreTravailAffichage';
import editionAchatDevisCommande from '@/components/devisCommandes/achat/editionAchatDevisCommande';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import exportExcel from '@/api/exportExcel';
import { SOCIETE_ROLE_VENTE, REGIE } from '@/configuration/societe/societe';
import { ECRAN_PLAN_MEDIA_DETAIL } from '@/configuration/bodac/planMedia/planMediaConfig';
import { TYPE_DONNE_EXPORT_RESEAU_NUM_PUBLID } from '@/configuration/dcf/dcfConf';
import updateModeCalculHonoraireLigneCommandeHonoraire from '@/services/ligneCommande/updateModeCalculHonoraire';
import setAFacturerAndFournisseurIfRegie from '@/services/devisCommandes/bonAFacturer/setAFacturerAndFournisseurIfRegie';
import updateInfoLogistiqueLigneCmd from '@/services/bodac/commande/ligneCommande/updateInfoLogistiqueLigneCmd';
import validationLignesCommande from '@/services/dcf/validation/validationVentePartielle';
import validationLigneEcheance from '@/services/devisCommandes/validation/validationLigneEcheance';
import validationPatrimoine from '@/services/gabed/patrimoine/validationPatrimoine';
import { COMMANDE_ETAT } from '@/configuration/commande/commandeConf';
import * as typesProduitSponsoring from '@/store/modules/bodac/catalogue/produitSponsoring-mutation-type';
import * as typesProduitAutre from '@/store/modules/bodac/catalogue/produitAutre-mutation-type';
import dateRenouvellementGenerator from '@/services/devisCommandes/dateRenouvellementGenerator';
import calculTlpe from '@/services/dcf/tlpe/calculTlpe';
import commissions from '@/components/planMedia/edition/commissions';
import avertissementMsgComponent from '@/components/general/avertissementMsgComponent';
import { gestionPlanMediaDcf } from '@/services/dcf/planMedia/gestionPlanMediaDcf';
import inputCurrency from '@/components/general/inputCurrency';
import regleFacturationInitialize from '@/services/devisCommandes/regleFacturationInitialize';
import etatSuiviDevisCommande from '@/components/devisCommandes/presse/etatSuiviDevisCommande/etatSuiviDevisCommande';
import { getAll as getAllOtTechnique } from '@/api/logistique/ordreTravailTech';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import userSelector from '@/components/commun/user/userSelector';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import { getSocietePublid } from '@/services/excel/produitReseauNumerique/getProduitsLocForExportImportNum';
import selectionCampagne from '@/components/devisCommandes/selectionCampagne';
import validationBonStock from '@/services/bonStock/validation/validation';
import agenceInitialize from '@/services/devisCommandes/agenceInitialize';
import IndexationCommande from '@/components/bodac/dcf/indexation/indexationCommandeEdit';
import { DOCUMENT_VENTE } from '@/configuration/parametrage/tagConf';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import * as interventionConf from '@/configuration/logistique/intervention/interventionConf';
import checkDcfBeforeSave from '@/services/bodac/lignesCommande/critereRecherche/checkBeforeSave';
import { besoinsCommandeManager } from '@/services/bodac/besoin/besoinService';
import AppRenouvellement from './editionDevisCommande/editRenouvellement';
import ConditionsReglement from './editionDevisCommande/conditionsReglement';
import SelectionClient from './editionDevisCommande/selectionClients';

const produitNumerique = createNamespacedHelpers('produitEcranNumerique');
const produitFace = createNamespacedHelpers('produitFace');
const Commandes = createNamespacedHelpers('commande');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Clients = createNamespacedHelpers('clients');
const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');
const ProduitReseauTempo = createNamespacedHelpers('planningReseauTempo');
const ProduitReseauLc = createNamespacedHelpers('produitReseauLc');
const ProduitReseauMairie = createNamespacedHelpers('produitReseauMairie');
const ProduitSalon = createNamespacedHelpers('produitSalon');
const ProduitSponsoring = createNamespacedHelpers('produitSponsoring');
const ProduitAutre = createNamespacedHelpers('produitAutre');
const ProduitPresse = createNamespacedHelpers('produitPresse');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  name: 'editionCommande',
  props: [],
  components: {
    listeLignesVentes,
    appBreadcrumb: AppBreadcrumb,
    appConditionsReglement: ConditionsReglement,
    appSelectionClient: SelectionClient,
    appPiecesJointes: PiecesJointes,
    AppRenouvellement,
    popupErreur,
    errorMsgComponent,
    popUpImportExcel,
    commentaires,
    AppLogistique,
    AppPrevisualisation,
    popUpPrevention,
    echeancierFacturation,
    AppInformationMsgComponent,
    editionAchatDevisCommande,
    inputCurrency,
    avertissementMsgComponent,
    commissions,
    etatSuiviDevisCommande,
    pieceJointeButton,
    userSelector,
    selectionCampagne,
    IndexationCommande,
    queryTagsTagInput,
  },
  data() {
    return {
      id: null,
      warning: false,
      messagesWarning: [],
      isEditPrevisu: false,
      error: false,
      nouveauDevisCommande: null,
      popUpImportExcel: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      activeTab: null,
      popUpProduit: null,
      modal: {
        error: false,
        warningDateAlreadyCheck: false,
        warningTotalAlreadyCheck: false,
        title: '',
        subtitle: '',
        warningType: '',
        prevention: false,
      },
      messagesPopup: [],
      isComponentPopUpErreurPerso: false,
      masqueRemiseBase: false,
      lignesMasqueLigneBase: [],
      popUpChoiceSavePrevisualisation: false,
      showErrorDate: false,
      ordresTravails: [],
      lignesSansProduitMessage: [],
      constantes: {
        REGIE,
        CATEGORIE_DIVERS: produitConf.CATEGORIE_DIVERS,
        CATEGORIE_SALON: produitConf.CATEGORIE_SALON,
        CATEGORIE_SPONSORING: produitConf.CATEGORIE_SPONSORING,
        CATEGORIE_AUTRE: produitConf.CATEGORIE_AUTRE,
        COMMANDES,
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
        ASSISTANT_COMMERCIAL,
        DOCUMENT_VENTE,
      },
      searchPlanMedia: '',
      planMediaFilter: [],
      isFetchingPlanMedia: false,
    };
  },
  computed: {
    ...produitNumerique.mapGetters({
      panierNumerique: 'panier',
      regroupPersoNumerique: 'regroupementPersonnalise',
    }),
    ...produitFace.mapGetters({
      regroupPersoFace: 'regroupementPersonnalise',
      panierFace: 'panier',
      useEcranAjoutFace: 'useEcranAjout',
    }),
    ...ProduitReseauTempo.mapGetters({
      panierReseauTempo: 'panier',
      regroupPersoReseauTempo: 'regroupementPersonnalise',
      useEcranAjoutReseauTempo: 'useEcranAjout',
    }),
    ...ProduitReseauLc.mapGetters({
      panierReseauLc: 'panier',
      regroupPersoReseauLc: 'regroupementPersonnalise',
      useEcranAjoutReseauLc: 'useEcranAjout',
    }),
    ...ProduitReseauMairie.mapGetters({
      panierReseauMairie: 'panier',
      useEcranAjoutReseauMairie: 'useEcranAjout',
    }),
    ...ProduitSalon.mapGetters({
      panierSalon: 'panier',
      useEcranAjoutSalon: 'useEcranAjout',
    }),
    ...ProduitSponsoring.mapGetters({
      panierSponsoring: 'panier',
      useEcranAjoutSponsoring: 'useEcranAjout',
    }),
    ...ProduitAutre.mapGetters({
      panierAutre: 'panier',
      useEcranAjoutAutre: 'useEcranAjout',
    }),
    ...ProduitPresse.mapGetters({
      panierPresse: 'panier',
      useEcranAjoutPresse: 'useEcranAjout',
    }),
    ...Commandes.mapGetters({
      commandeCourante: 'commande',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Clients.mapGetters({
      clientCourant: 'clientCourant',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduit',
    }),
    isPublid() {
      return !!getSocietePublid();
    },
    isDateCampagneDisabled() {
      const typesDateCampagneEnabled = [
        this.constantes.CATEGORIE_DIVERS,
        this.constantes.CATEGORIE_SALON,
        this.constantes.CATEGORIE_SPONSORING,
        this.constantes.CATEGORIE_AUTRE,
      ];
      return !typesDateCampagneEnabled.includes(this.nouveauDevisCommande.categorieVente);
    },
    reglesFacturation() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.regleFacturation)
        .filter(r => r.societeId === (this.nouveauDevisCommande?.societeId
          || this.societeActiveId));
    },
    getUpdateTitle() {
      const etatFind = COMMANDE_ETAT.find((etat) => {
        return etat.code === this.nouveauDevisCommande.etat;
      });
      return this.$i18n.t('editionCommande.updateTitle', {
        etat: etatFind ? this.$i18n.t(etatFind.libelle).toLocaleLowerCase() : '',
        code: this.nouveauDevisCommande.code,
      });
    },
    displayRoundAlerteLogistique() {
      return (this.nouveauDevisCommande.lignesCommande.some((ligne) => {
        return (ligne.typeProduit === produitConf.CATEGORIE_UNITAIRE
          && ligne.datePlanifieeLogistiqueAffichage
          && !moment(ligne.datePlanifieeLogistiqueAffichage).isSame(moment(ligne.dateDebut))
          || ligne.isAffecteLogistiquement
        );
      }));
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeCommandes.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeCommandes.titleCommande'), route: { name: 'l.bodac.commandes-liste' }, isActive: false },
        { title: this.$i18n.t('editionCommande.title'), route: { name: 'm.bodac.commandes-ajout' }, isActive: true },
      ];
      if (!this.isNewDevisCommande) {
        output[2].title = this.$i18n.t('editionCommande.updateBreadcrumbTitle');
        output[2].route = { name: 'm.bodac.commandes', params: { id: this.id } };
      }
      return output;
    },
    isSyncRegleWithLignes() {
      if (this.nouveauDevisCommande.regleFacturationId) {
        return this.nouveauDevisCommande.lignesCommande.length > 0
          && this.nouveauDevisCommande.lignesCommande.some(ligne => {
            return ligne.produit
            && (ligne.produit.regleFacturationId === this.nouveauDevisCommande.regleFacturationId);
          });
      }
      return true;
    },
    canSeeCommande() {
      if (!this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key)) return true;
      return (this.isNewDevisCommande || this.utilisateur.profil !== COMMERCIAL
        || (this.utilisateur.profil === COMMERCIAL
          && this.utilisateur.id === this.nouveauDevisCommande.commercialId));
    },
    isNewDevisCommande() {
      return this.nouveauDevisCommande
        && (!this.nouveauDevisCommande.id
          || this.nouveauDevisCommande.id === GUID_VIDE);
    },
    isCommercial() {
      return ((this.isNewDevisCommande && this.utilisateur.profil === COMMERCIAL)
        || (!this.isNewDevisCommande && this.utilisateur.profil === COMMERCIAL
          && this.utilisateur.id === this.nouveauDevisCommande.commercialId));
    },
    getRoleOfCurrentSociete() {
      return SOCIETE_ROLE_VENTE.filter((role) => {
        return this.societeActive.roles.includes(role.code);
      });
    },
    intervenantsPayeurs() {
      return this.nouveauDevisCommande.intervenants.filter(i => i.payeur);
    },
    getTitle() {
      if (this.$route.params.renouveleOrTacite === devisConf.ETAT_TACITE) {
        return this.$t('editionCommande.issuTacite');
      }
      if (this.$route.params.renouveleOrTacite === devisConf.ETAT_RENOUVELEE) {
        return this.$t('editionCommande.issuRenouvellement');
      }
      if (!this.nouveauDevisCommande.historique) return '';
      const index = this.nouveauDevisCommande.historique.findIndex((commande) => {
        return commande.id === this.$route.params.id;
      });
      if (index !== this.nouveauDevisCommande.historique.length - 1) {
        if (this.nouveauDevisCommande.historique[index + 1].etatRenouvellement
          === devisConf.ETAT_TACITE) {
          return this.$t('editionCommande.issuTacite');
        }
        if (this.nouveauDevisCommande.historique[index + 1].etatRenouvellement
          === devisConf.ETAT_RENOUVELEE) {
          return this.$t('editionCommande.issuRenouvellement');
        }
      }
      return '';
    },
    modulePresseActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleCampagneActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.campagne.key);
    },
    moduleLogistiqueTechnique() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key,
      );
    },
    periodeTotalCalculTlpeAuto() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key,
      );
    },
    moduleIndexationCommandeActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key);
    },
    assistantEtCommercialObligatoireSurCommandeFacture() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS
        .rendreObligatoireAssistantEtCommercialSurCommandeFacture.key);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
  },
  methods: {
    ...produitNumerique.mapMutations({
      clearBriefNumerique: typesProduitNumerique.CLEAR_BRIEF,
      clearPanierNumerique: typesProduitNumerique.CLEAR_PANIER,
    }),
    ...ProduitReseauTempo.mapMutations({
      clearBriefReseauTempo: typesProduitReseauTempo.CLEAR_BRIEF,
      clearPanierReseauTempo: typesProduitReseauTempo.CLEAR_PANIER,
      setTypeDCFReseauTempo: typesProduitReseauTempo.SET_TYPE_DCF,
      setUseEcranAjoutReseauTempo: typesProduitReseauTempo.SET_USE_ECRAN_AJOUT,
    }),
    ...produitFace.mapMutations({
      clearBriefFace: typesProduitFace.CLEAR_BRIEF,
      clearPanierFace: typesProduitFace.CLEAR_PANIER,
      setTypeDCFFace: typesProduitFace.SET_TYPE_DCF,
      setUseEcranAjoutFace: typesProduitFace.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitReseauLc.mapMutations({
      clearBriefReseauLc: typesProduitReseauLc.CLEAR_BRIEF,
      clearPanierReseauLc: typesProduitReseauLc.CLEAR_PANIER,
      setTypeDCFReseauLc: typesProduitReseauLc.SET_TYPE_DCF,
      setUseEcranAjoutReseauLc: typesProduitReseauLc.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitReseauMairie.mapMutations({
      clearBriefReseauMairie: typesProduitReseauMairie.CLEAR_BRIEF,
      clearPanierReseauMairie: typesProduitReseauMairie.CLEAR_PANIER,
      setTypeDCFReseauMairie: typesProduitReseauMairie.SET_TYPE_DCF,
      setUseEcranAjoutReseauMairie: typesProduitReseauMairie.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitSalon.mapMutations({
      clearBriefSalon: typesProduitSalon.CLEAR_BRIEF,
      clearPanierSalon: typesProduitSalon.CLEAR_PANIER,
      setTypeDCFSalon: typesProduitSalon.SET_TYPE_DCF,
      setUseEcranAjoutSalon: typesProduitSalon.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitSponsoring.mapMutations({
      clearBriefSponsoring: typesProduitSponsoring.CLEAR_BRIEF,
      clearPanierSponsoring: typesProduitSponsoring.CLEAR_PANIER,
      setTypeDCFSponsoring: typesProduitSponsoring.SET_TYPE_DCF,
      setUseEcranAjoutSponsoring: typesProduitSponsoring.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitAutre.mapMutations({
      clearBriefAutre: typesProduitAutre.CLEAR_BRIEF,
      clearPanierAutre: typesProduitAutre.CLEAR_PANIER,
      setTypeDCFAutre: typesProduitAutre.SET_TYPE_DCF,
      setUseEcranAjoutAutre: typesProduitAutre.SET_USE_ECRAN_AJOUT,
    }),
    ...ProduitPresse.mapMutations({
      clearBriefPresse: typesProduitPresse.CLEAR_BRIEF,
      clearPanierPresse: typesProduitPresse.CLEAR_PANIER,
      setTypeDCFPresse: typesProduitPresse.SET_TYPE_DCF,
      setUseEcranAjoutPresse: typesProduitPresse.SET_USE_ECRAN_AJOUT,
    }),
    ...Commandes.mapMutations({
      removeCommande: types.REMOVE_COMMANDE,
    }),
    ...Clients.mapMutations({
      setClientCourant: typesClient.SET_CLIENT_COURANT,
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    setCommissions(commercialId) {
      if (!this.modulePresseActive || this.nouveauDevisCommande.commissions.length > 1) return;
      if (!commercialId) this.nouveauDevisCommande.commissions = [];
      else {
        this.nouveauDevisCommande.commissions = [{
          commercialId: commercialId,
          pourcentageRepartition: 100,
          selected: false,
        }];
      }
    },
    async setActiveTabCommande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.nouveauDevisCommande.id) {
          await this.setAttachmentContext({ module: 'Commande' });
          await this.setAttachmentElementId({ id: this.nouveauDevisCommande.id });
        }
        this.activeTab = 'commande';
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    checkBeforeSave() {
      this.lignesSansProduitMessage = checkDcfBeforeSave(this.nouveauDevisCommande);
      if (this.lignesSansProduitMessage.length) {
        this.popUpProduit = true;
      } else this.enregistrerDevisCommande();
    },
    saveCommande() {
      this.popUpProduit = false;
      this.enregistrerDevisCommande();
    },
    isProduitTlpe(ligneCommande) {
      return !!(ligneCommande.produit && ligneCommande.produit.produitDivers
        && ligneCommande.produit.produitDivers.tlpe);
    },
    getRemiseTvaDefaut(commande) {
      const agenceFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === commande.agenceId;
      });
      const regimesTva = this.parametre(typesParametres.PARAMETRES_KEYS.regimeTva);
      if (!agenceFind.regimeTvaId) return null;
      const regimeFind = regimesTva.find((regime) => {
        return regime.id === agenceFind.regimeTvaId;
      });
      return regimeFind ? regimeFind.tauxTva : null;
    },
    checkCategorieVente() {
      if (this.nouveauDevisCommande.categorieVente !== produitConf.CATEGORIE_UNITAIRE) return;
      this.nouveauDevisCommande.renouvelable = true;
      this.nouveauDevisCommande.reconductible = true;
      dateRenouvellementGenerator(this.nouveauDevisCommande);
    },
    masqueLigneChange(ligne) {
      updateMasqueLigneWithOrdre(
        this.nouveauDevisCommande.lignesCommande, ligne.ordre, !ligne.masqueLigne,
      );
    },
    getLignesMasqueLigne(lignesCommande) {
      lignesCommande.forEach((ligne) => {
        if (ligne.lignesCommande) {
          const lignesFind = ligne.lignesCommande.filter((ligneEnfant) => {
            return ligneEnfant.masqueLigne && ligneEnfant.id;
          });
          if (lignesFind) {
            this.lignesMasqueLigneBase = this.lignesMasqueLigneBase.concat(cloneDeep(lignesFind));
          }
        }
      });
    },
    async getExcelProduitReseauNum() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: TYPE_DONNE_EXPORT_RESEAU_NUM_PUBLID,
          nomFichier: '',
          typeExport: '',
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        messageSucces(this.$i18n.t('exportExcelReseauNum.messages.sucessCreationExcel'));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('exportExcelReseauNum.messages.excelExportError'));
        loadingComponent.close();
        throw (e);
      }
    },
    async readAndCreateLignes(file) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const lignesXlsx = await readFileXlsx(file);
        const tabDonnnes = fromLignesXlsxToTab(lignesXlsx);
        if (tabDonnnes.length === 0) throw new Error();
        await ajoutLignesCommandeProduitReseauNumfromXlsx(
          this.nouveauDevisCommande, tabDonnnes,
          this.$i18n, this.getRemiseTvaDefaut(this.nouveauDevisCommande),
        );
        this.changeOrder();
        this.calcul();
        this.findNewTypeProduit();
        messageSucces(this.$i18n.t('importExcel.messages.sucessCreationLignes'));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('importExcel.messages.errorCreationLignes'));
        loadingComponent.close();
        throw (e);
      }
    },
    findNewTypeProduit() {
      categorieVenteInitialize(this.nouveauDevisCommande);
    },
    changeMasqueLigneToInitalMasqueLigne(lignesCommande) {
      lignesCommande.forEach((ligne) => {
        if (ligne.lignesCommande) {
          ligne.lignesCommande.forEach((ligneEnfant) => {
            const ligneInitial = this.lignesMasqueLigneBase.find((ligne) => {
              return ligneEnfant.id && ligne.id === ligneEnfant.id;
            });
            if (ligneInitial) ligneEnfant.masqueLigne = ligneInitial.masqueLigne;
            else ligneEnfant.masqueLigne = false;
          });
        }
      });
    },
    calcul() {
      calculCommandeDevis(this.nouveauDevisCommande);
      if (this.modulePresseActive && !this.nouveauDevisCommande.regleFacturationId) {
        regleFacturationInitialize(this.nouveauDevisCommande);
      }
    },
    changeOrder() {
      // On réordonne les éléments liées à un réseau personnalisé
      // pour les mettre en dessous de la ligne de réseau personnalisé
      reordonnancementRegroupementPersonnalise(this.nouveauDevisCommande.lignesCommande);
      this.nouveauDevisCommande.lignesCommande.forEach((ligneCommande) => {
        ajoutOrdre(ligneCommande, this.nouveauDevisCommande.lignesCommande.indexOf(ligneCommande));
      });
      this.calcul();
    },
    saveWithChange() {
      this.isEditPrevisu = false;
      this.popUpChoiceSavePrevisualisation = false;
      this.enregistrerDevisCommande();
    },
    saveWithoutChange() {
      this.isEditPrevisu = false;
      this.nouveauDevisCommande.masqueRemise = this.masqueRemiseBase;
      this.popUpChoiceSavePrevisualisation = false;
      this.changeMasqueLigneToInitalMasqueLigne(this.nouveauDevisCommande.lignesCommande);
      this.enregistrerDevisCommande();
    },
    async enregistrerDevisCommande() {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      this.error = false;
      if (this.checkTotalError()) return;
      if (this.checkDateError()) return;
      if (this.isEditPrevisu) {
        this.popUpChoiceSavePrevisualisation = true;
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.isCommercial) this.nouveauDevisCommande.commercialId = this.utilisateur.id;
        const copieNouveauDevisCommande = preparationEnvoiBack(this.nouveauDevisCommande);
        let commande = {};
        setAFacturerAndFournisseurIfRegie(this.nouveauDevisCommande);
        if (this.isNewDevisCommande) {
          copieNouveauDevisCommande.societeId = this.societeActiveId;
          commande = (await create(copieNouveauDevisCommande)).data.result;
          await this.insertAttachments(commande.id);
          messageSucces(this.$i18n.t('editionCommande.messages.successCreation'));
        } else {
          commande = (await update(copieNouveauDevisCommande)).data.result;
          await this.updateAttachments(commande.id);
          messageSucces(this.$i18n.t('editionCommande.messages.editQuotationSuccess'));
        }
        loadingComponent.close();
        if (this.$route.params.planMediaId) {
          this.goToPlanMedia();
          return;
        }
        await this.$router.push({ name: 'c.bodac.commandes', params: { id: commande.id } });
      } catch (e) {
        if (e.response) {
          this.error = true;
          validationDevisCommande(e.response,
            this.messages,
            this.isNewDevisCommande,
            devisConf.TYPE_COMMANDE);
          await validationLignesCommande(e.response, this.messages, this.nouveauDevisCommande);
          validationLigneEcheance(e.response, this.messages,
            this.nouveauDevisCommande.lignesCommande, devisConf.TYPE_COMMANDE);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationBonStock(e.response, this.messages);
          validationPatrimoine(e.response, this.messages);
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    showErrorsMessages(messages) {
      this.error = true;
      this.messages = messages;
    },
    annuler() {
      if (this.$route.params.planMediaId) {
        this.goToPlanMedia();
        return;
      }
      this.$router.go(-1);
    },
    goToPlanMedia() {
      let nameRoutePlanMedia = 'm.presse.plan_media-edit';
      if (this.$route.params?.typeEcran === ECRAN_PLAN_MEDIA_DETAIL) {
        nameRoutePlanMedia = 'c.presse.plan_media';
      }
      this.$router.push({
        name: nameRoutePlanMedia,
        params: { id: this.$route.params.planMediaId },
      });
    },
    displayErrorEcheancier() {
      this.modal.prevention = false;
      if (this.modal.warningType === 'date') this.showErrorDate = true;
      this.modal.warningTotalAlreadyCheck = false;
      this.modal.warningDateAlreadyCheck = false;
    },
    checkTotalError() {
      if (this.modal.warningTotalAlreadyCheck) return false;
      let errorTotal = false;
      this.nouveauDevisCommande.echeanciers.forEach((echeancier) => {
        if (echeancier.quantitePeriodicite === 0) return;
        const lignesCommandeWithReference = getLignesCommandesWithReferenceEcheancier(
          this.nouveauDevisCommande.lignesCommande, echeancier.referenceEcheancier,
        );
        const totalEcheanciers = echeancier.echeancierLignes.length > 0
          ? echeancier.echeancierLignes
            .map((ligne) => { return ligne.montant; })
            .reduce((montantTotal, montant) => montantTotal + montant) : 0;
        const totalLignesCommande = lignesCommandeWithReference
          .map((ligne) => { return ligne.totalHtAvecLigneRemise; })
          .reduce((montantTotal, montant) => montantTotal + montant);
        if (totalEcheanciers.toFixed(2) !== totalLignesCommande.toFixed(2)) errorTotal = true;
      });
      if (!errorTotal) return false;
      this.modal.title = this.$i18n.t('echeancierFacturation.messages.prevention.total_different.title');
      this.modal.subtitle = this.$i18n.t('echeancierFacturation.messages.prevention.total_different.subTitle');
      this.modal.warningType = 'total';
      this.modal.prevention = true;
      return true;
    },
    checkDateError() {
      if (this.modal.warningDateAlreadyCheck) return false;
      const unconsecutiveDate = checkUnconsecutiveDateEcheancier(
        this.nouveauDevisCommande.echeanciers, this.intervenantsPayeurs,
      );
      if (!unconsecutiveDate) return false;
      this.modal.title = this.$i18n.t('echeancierFacturation.messages.prevention.unconsecutive_date.title');
      this.modal.subtitle = this.$i18n.t('echeancierFacturation.messages.prevention.unconsecutive_date.subTitle');
      this.modal.warningType = 'date';
      this.modal.prevention = true;
      return true;
    },
    checkAlredyPassErrorDateOrTotal() {
      this.modal.prevention = false;
      if (this.modal.warningType === 'date') this.modal.warningDateAlreadyCheck = true;
      else this.modal.warningTotalAlreadyCheck = true;
      this.enregistrerDevisCommande();
    },
    deleteOrDeselectPayeurInEcheancier(isDelete) {
      this.modal.error = true;
      this.modal.title = this.$i18n.t('echeancierFacturation.messages.errors.' + (isDelete ? 'payeurDelete' : 'payeurDeselect') + '.title');
      this.modal.subtitle = this.$i18n.t('echeancierFacturation.messages.errors.' + (isDelete ? 'payeurDelete' : 'payeurDeselect') + '.subTitle');
    },
    async getAllDemandeLogistiqueAsync() {
      if (this.nouveauDevisCommande.lignesCommande.filter(l => l.id).length === 0) return;
      let idsLigneCommande = this.nouveauDevisCommande.lignesCommande
        .map(l => l.id).filter(Boolean);
      this.nouveauDevisCommande.lignesCommande
        .filter(ligne => ligne.lignesCommande)
        .forEach(ligne => {
          const ids = ligne.lignesCommande.map(l => l.id).filter(Boolean);
          idsLigneCommande = idsLigneCommande.concat(ids);
        });
      const param = {
        query: {
          ligneCommandeIds: idsLigneCommande,
          societeId: this.societeActiveId,
          types: [
            interventionConf.INTERVENTION_TYPE_INTERVENTION,
            interventionConf.INTERVENTION_TYPE_AFFICHAGE,
            interventionConf.INTERVENTION_TYPE_NON_DEFINI,
          ],
        },
      };
      const result = (await getAll(param)).data.result.items;
      this.nouveauDevisCommande.lignesCommande.forEach(l => {
        let idsLignes = [l.id];
        if (l.lignesCommande) {
          idsLignes = idsLignes.concat(l.lignesCommande.map(le => le.id));
        }
        const demandes = result.filter(d => idsLignes.includes(d.ligneCommandeId));
        if (demandes) {
          l.demandesLogistique = demandes;
        }
      });
    },
    getAsyncPlanMediaData: debounce(async function getData(text) {
      if (text === this.searchPlanMedia) return;
      try {
        this.isFetchingPlanMedia = true;
        const payload = {
          skipCount: 0,
          maxResultCount: RESULTS_PER_PAGE,
          query: {
            auto: text,
            societeId: this.societeActiveId,
          },
        };
        serverTableDataTransformer(payload);
        this.planMediaFilter = (await getAllPlanMedia(payload))
          .data.result.items;
        this.isFetchingPlanMedia = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingPlanMedia = false;
        throw e;
      }
    }),
    setPlanMedia(planMedia) {
      if (!planMedia) return;
      this.searchPlanMedia = planMedia.code;
      this.nouveauDevisCommande.planMediaId = planMedia.id;
      this.nouveauDevisCommande.planMedia = planMedia;
    },
    async getAllOtTechniques() {
      const produits = this.nouveauDevisCommande.lignesCommande
        .filter((l) => {
          return l.typeProduit === produitConf.CATEGORIE_UNITAIRE
            && l.produit.produitFace;
        }).map(p => p.produit.produitFace);
      if (produits.length === 0) return;
      const param = {
        query: {
          facesId: produits.filter((p) => {
            return p.faceId !== null;
          }).map(p => p.faceId),
          societeId: this.societeActiveId,
          agencesId: this.agencesSelectionnees.map(agence => agence.agenceId),
        },
      };
      const result = (await getAllOtTechnique(param)).data.result;
      if (result) {
        this.nouveauDevisCommande.lignesCommande.forEach(l => {
          if (l.typeProduit === produitConf.CATEGORIE_UNITAIRE && l.produit.produitFace) {
            const otPatrimoines = result.items.filter((ot) => {
              return ot.otPatrimoine;
            });
            const otTechniques = otPatrimoines.filter((ot) => {
              return ot.otPatrimoine.faceId
                && ot.otPatrimoine.faceId === l.produit.produitFace.faceId;
            });
            l.otTechniques = otTechniques;
          }
        });
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.messagesWarning = [];
    this.warning = false;
    this.setTypeDCFFace(devisConf.TYPE_COMMANDE);
    this.setTypeDCFReseauLc(devisConf.TYPE_COMMANDE);
    this.setTypeDCFReseauTempo(devisConf.TYPE_COMMANDE);
    this.setTypeDCFReseauMairie(devisConf.TYPE_COMMANDE);
    await this.loadParametres([
      typesParametres.PARAMETRES_KEYS.regimeTva,
      typesParametres.PARAMETRES_KEYS.regleFacturation,
    ]);
    await this.loadParametreUtilisateur();
    await this.loadParametresInterne([typesParametres.PARAMETRES_INTERNE_KEYS.modulePresse.key,
      typesParametres.PARAMETRES_INTERNE_KEYS.signatureElectronique.key,
      typesParametres.PARAMETRES_INTERNE_KEYS
        .rendreObligatoireAssistantEtCommercialSurCommandeFacture.key,
      typesParametres.PARAMETRES_INTERNE_KEYS.modulePlanMedia.key,
      typesParametres.PARAMETRES_INTERNE_KEYS.moduleIndexationCommande.key,
      typesParametres.PARAMETRES_INTERNE_KEYS.campagne.key,
    ]);
    await this.setAttachmentContext({ module: 'Commande' });
    if (this.commandeCourante) {
      const messages = [];
      let nouveauDevisCommande = this.commandeCourante;
      this.masqueRemiseBase = nouveauDevisCommande.masqueRemise;
      this.getLignesMasqueLigne(nouveauDevisCommande.lignesCommande);
      initializeCommandeDevis(nouveauDevisCommande);
      nouveauDevisCommande = await ajouterProduitDepuisPanierNumerique(
        this.panierNumerique, nouveauDevisCommande, this.regroupPersoNumerique,
        this.$i18n, messages, this.getRemiseTvaDefaut(nouveauDevisCommande),
      );
      if (this.useEcranAjoutFace) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierFace, nouveauDevisCommande, this.regroupPersoFace, this.$i18n, messages,
          produitConf.CATEGORIE_UNITAIRE, this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefFace();
        this.clearPanierFace();
        this.setUseEcranAjoutFace(false);
      }
      if (this.useEcranAjoutReseauTempo) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierReseauTempo, nouveauDevisCommande, this.regroupPersoReseauTempo, this.$i18n,
          messages, produitConf.CATEGORIE_REGROUPEMENT,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefReseauTempo();
        this.clearPanierReseauTempo();
        this.setUseEcranAjoutReseauTempo(false);
      }
      if (this.useEcranAjoutReseauLc) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierReseauLc, nouveauDevisCommande, this.regroupPersoReseauLc,
          this.$i18n, messages, produitConf.CATEGORIE_REGROUPEMENT_LC,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefReseauLc();
        this.clearPanierReseauLc();
        this.setUseEcranAjoutReseauLc(false);
      }
      if (this.useEcranAjoutReseauMairie) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierReseauMairie, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_REGROUPEMENT_MAIRIE,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefReseauMairie();
        this.clearPanierReseauMairie();
        this.setUseEcranAjoutReseauMairie(false);
      }
      if (this.useEcranAjoutSalon) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierSalon, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_SALON,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefSalon();
        this.clearPanierSalon();
        this.setUseEcranAjoutSalon(false);
      }
      if (this.useEcranAjoutSponsoring) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierSponsoring, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_SPONSORING,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefSponsoring();
        this.clearPanierSponsoring();
        this.setUseEcranAjoutSponsoring(false);
      }
      if (this.useEcranAjoutAutre) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierAutre, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_AUTRE,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefAutre();
        this.clearPanierAutre();
        this.setUseEcranAjoutAutre(false);
      }
      if (this.useEcranAjoutPresse) {
        nouveauDevisCommande = await ajouterProduitDepuisPanierFaceOrReseauLcOrReseauTempo(
          this.panierPresse, nouveauDevisCommande, false,
          this.$i18n, messages, produitConf.CATEGORIE_PRESSE,
          this.getRemiseTvaDefaut(nouveauDevisCommande),
        );
        this.clearBriefPresse();
        this.clearPanierPresse();
        this.setUseEcranAjoutPresse(false);
      }
      nouveauDevisCommande.lignesCommande.forEach((ligne) => {
        ligne.selected = false;
      });
      await updateAffectionOfAllProduct(nouveauDevisCommande);
      if (this.societeActive.roles.length > 0 && !nouveauDevisCommande.role) {
        nouveauDevisCommande.role = this.societeActive.roles[0];
      }
      await updateModeCalculHonoraireLigneCommandeHonoraire(
        nouveauDevisCommande.lignesCommande,
        nouveauDevisCommande.intervenants,
      );
      if (nouveauDevisCommande.role !== REGIE
        && nouveauDevisCommande.lignesCommande.filter((ligne) => {
          return ligne.type === devisConf.REGROUPEMENT;
        }).length === 1) {
        nouveauDevisCommande.notUpdateDatePreavis = false;
      }
      if (nouveauDevisCommande.planMediaId) {
        this.searchPlanMedia = nouveauDevisCommande.planMedia?.code;
      }
      this.nouveauDevisCommande = nouveauDevisCommande;
      if (this.nouveauDevisCommande.msgAvertissementVentePartielle
        && this.nouveauDevisCommande.msgAvertissementVentePartielle.length > 0) {
        this.warning = true;
        this.messagesWarning = cloneDeep(this.nouveauDevisCommande.msgAvertissementVentePartielle);
        delete this.nouveauDevisCommande.msgAvertissementVentePartielle;
      }
      this.clearBriefNumerique();
      this.clearPanierNumerique();
      this.removeCommande();
      if ((this.regroupPersoNumerique && this.panierNumerique)
        || (this.regroupPersoFace && this.panierFace.length > 0)
        || (this.regroupPersoReseauLc && this.panierReseauLc.length > 0)
        || (this.regroupPersoReseauTempo && this.panierReseauTempo.length > 0)) {
        this.changeOrder();
        if (messages.length > 0) {
          this.messagesPopup = messages;
          this.isComponentPopUpErreurPerso = true;
        }
      }
      if (this.$route.name === 'm.bodac.commandes-client' && this.clientCourant !== null) {
        addIntervenant(this.nouveauDevisCommande, creerIntervenant(this.clientCourant));
        this.setClientCourant(null);
      }
      this.findNewTypeProduit();
    } else {
      this.id = this.$route.params.id;
      let nouveauDevisCommande = null;
      if (this.id) {
        try {
          this.ordresTravails = (await getOdresTravailsOfCommande(this.id))
            .data.result;
          if (this.$route.params.renouveleOrTacite) {
            try {
              nouveauDevisCommande = {
                ...(
                  await commandeRenouvellementTaciteGetter(
                    this.id,
                    this.$route.params.renouveleOrTacite,
                  )),
              };
              if (nouveauDevisCommande.role !== REGIE
                && nouveauDevisCommande.lignesCommande.filter((ligne) => {
                  return ligne.type === devisConf.REGROUPEMENT;
                }).length === 1) {
                nouveauDevisCommande.notUpdateDatePreavis = false;
              }
            } catch (e) {
              validationDevisCommande(e.response, this.messages, null, devisConf.TYPE_COMMANDE);
              if (this.messages?.length > 0) {
                this.messages.forEach(message => {
                  messageErreur(this.$i18n, this.$i18n.t(message.message, message.parametres));
                });
              } else {
                messageErreur(this.$i18n);
              }
              loadingComponent.close();
              this.$router.go(-1);
              return;
            }
          } else {
            nouveauDevisCommande = { ...(await devisCommandeGetter(this.id)) };
            if (nouveauDevisCommande.interne === true) {
              const routeName = nouveauDevisCommande.sens === devisConf.SENS_VENTE ? 'c.bodac.commandes-venteInterne' : 'c.bodac.commandes-achatVenteInterne';
              await this.$router.push({ name: routeName, params: { id: nouveauDevisCommande.id } });
              loadingComponent.close();
              return;
            }
          }
          nouveauDevisCommande.lignesCommande.forEach((ligne) => {
            ligne.selected = false;
            if (this.societeActive.roleParDefaut === REGIE) return;
            if (!ligne.lignesCommande || ligne.lignesCommande.length === 0) {
              ligne.libelleFournisseur = null;
              return;
            }
            ligne.lignesCommande.forEach((ligneEnfant) => {
              ligneEnfant.libelleFournisseur = null;
            });
          });
          try {
            nouveauDevisCommande.lignesCommande
              .filter(ligne => ligne.type === devisConf.REGROUPEMENT
                      && ligne.lignesCommande.some(ligneEnfant => this.isProduitTlpe(ligneEnfant)))
              .forEach(async ligneParent => {
                await calculTlpe(ligneParent, false, this.periodeTotalCalculTlpeAuto, null);
              });
          } catch (e) {
            nouveauDevisCommande.lignesCommande.forEach(ligneParent => {
              ligneParent.lignesCommande.forEach(ligneEnfant => {
                if (ligneEnfant.typeProduit === produitConf.CATEGORIE_DIVERS
                  && ligneEnfant.calculAutomatiqueTlpe && ligneEnfant.produit.produitDivers.tlpe) {
                  ligneEnfant.prixUnitaire = 0;
                }
              });
            });
          }
          nouveauDevisCommande.echeanciers.forEach((echeancier) => {
            echeancier.select = false;
          });
          if (nouveauDevisCommande.planMediaId) {
            this.searchPlanMedia = nouveauDevisCommande.planMedia?.code;
          }
          await updateAffectionOfAllProduct(nouveauDevisCommande);
          await updateInfoLogistiqueLigneCmd(nouveauDevisCommande);
          await besoinsCommandeManager(nouveauDevisCommande);
          this.masqueRemiseBase = nouveauDevisCommande.masqueRemise;
          this.getLignesMasqueLigne(nouveauDevisCommande.lignesCommande);
        } catch (e) {
          messageErreur(this.$i18n);
          loadingComponent.close();
          throw e;
        }
      } else {
        nouveauDevisCommande = genererDevisCommande(
          devisConf.TYPE_COMMANDE,
          devisConf.NORMAL,
          this.societeActive,
          devisConf.SENS_VENTE,
          devisConf.MODULE_GESTION_COMMERCIALE,
        );
        agenceInitialize(nouveauDevisCommande);
        if (this.utilisateur.profil === ASSISTANT_COMMERCIAL) {
          nouveauDevisCommande.assistantId = this.utilisateur.id;
        }
        if (this.utilisateur.profil === COMMERCIAL) {
          nouveauDevisCommande.commercialId = this.utilisateur.id;
          nouveauDevisCommande.commissions = [{
            commercialId: this.utilisateur.id,
            pourcentageRepartition: 100,
            selected: false,
          }];
        }
        if (this.societeActive.roles.length > 0) {
          nouveauDevisCommande.role = this.societeActive.roles[0];
        }
        const planMedia = await gestionPlanMediaDcf(
          nouveauDevisCommande,
          this.$route.params.planMediaId,
        );
        nouveauDevisCommande.planMedia = planMedia;
        this.searchPlanMedia = planMedia?.code;
      }
      initializeCommandeDevis(nouveauDevisCommande);
      this.nouveauDevisCommande = nouveauDevisCommande;
      this.calcul();
    }
    this.setCommissions(this.nouveauDevisCommande.commercialId);
    await this.getAllDemandeLogistiqueAsync();
    if (this.moduleLogistiqueTechnique) {
      await this.getAllOtTechniques();
    }
    await this.setActiveTabCommande();
    loadingComponent.close();
    if (this.isNewDevisCommande) {
      this.setInformationPage(this.$t('pageGescom.commande.creation'));
    } else {
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.nouveauDevisCommande.code }));
    }
  },
};
</script>
